import { Box } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  height: theme.typography.pxToRem(496),

  [theme.breakpoints.down('xl')]: {
    height: theme.typography.pxToRem(380),
  },
  [theme.breakpoints.down('lg')]: {
    height: theme.typography.pxToRem(222),
    backgroundColor: alpha(theme.palette.grey[900], 0.9),
  },
  [theme.breakpoints.down('md')]: {
    height: theme.typography.pxToRem(327),
  },

  '& .FHcontent': {
    color: theme.palette.common.fogWhite,
    [theme.breakpoints.up('lg')]: {
      backgroundColor: alpha(theme.palette.grey[900], 0.9),
      padding: theme.spacing(4, 3),
      width: theme.typography.pxToRem(589),
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },

  '& .MWCSImgContainer': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: '-1',
  },

  '& .FHBtnContainer': {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      '& .MuiButton-root': {
        width: '100%',
      },
    },
  },
  '& .FHAboutBtn': {
    color: theme.palette.primary.main,
  },
}));
export default StyledBox;
